<template>
  <div class="map-wrapper">
    <vue-daum-map
      :appKey="appKey"
      :center.sync="center"
      :level.sync="level"
      :mapTypeId="mapTypeId"
      :libraries="libraries"
      :style="{width:'100%', height: '100%'}"
      v-if="center.lat && center.lng"
      @load="loadMaps"
    >

    </vue-daum-map>

  </div>
</template>
<script>
  import VueDaumMap from 'vue-daum-map'
  // import stations from '../const/subwayStations'

  import collages from '../const/collages'
  export default {
    name: 'Test',
    components: {
      VueDaumMap
    },
    data: () => ({
      appKey: 'ba6cde83c830d56de6f7f8835ffd79f4', // 테스트용 appkey
      center: {
        lat: 37.566485, lng: 126.978347
      }, // 지도의 중심 좌표
      level: 3, // 지도의 레벨(확대, 축소 정도),
      mapTypeId: VueDaumMap.MapTypeId.NORMAL, // 맵 타입
      libraries: ['services', 'clusterer', 'drawing'], // 추가로 불러올 라이브러리
      map: null, // 지도 객체. 지도가 로드되면 할당됨.
      clusterManager: null,
      polyline: null,
      markers: [],
      latlngBound: null,
      initMapDoLevel: 9,
      initMapCityLevel: 9,
      initMapSearchLevel: 6,
      cityOverlay: null,
      stateOverlay: null,
      clickedItem: null,
      overlayList: []
    }),
    methods: {
      loadMaps (context) {
        this.map = context
        this.drawMarker()

        // 커스텀 오버레이를 닫기 위해 호출되는 함수입니다
        window.closeOverlay = function(index) {
          this.overlayList[index].setMap(null)
        }
      },
      drawMarker () {
        console.log(collages)
        for ( let i = 0; i < collages.length; i ++ ) {

          const markerPosition  = new this.daum.maps.LatLng(collages[i].lat, collages[i].lng)

          const marker = new this.daum.maps.Marker({
            position: markerPosition
          })

          var content = '<div class="wrap">' +
            '    <div class="info">' +
            '        <div class="title">' +
            collages[i].name +
            '            ' +
            '            <div class="close" onclick="closeOverlay(' + i + ')" title="닫기"></div>' +
            '        </div>' +
            '    </div>' +
            '</div>'

          var overlay = new this.daum.maps.CustomOverlay({
            content: content,
            map: this.map,
            position: marker.getPosition()
          })

          this.overlayList.push(overlay)

          // 마커를 클릭했을 때 커스텀 오버레이를 표시합니다
          this.daum.maps.event.addListener(marker, 'click', function() {
            overlay.setMap(this.map)
          })
          console.log(marker)
          marker.setMap(this.map)
        }
      }
    }
  }
</script>
<style scoped lang="less">
  .map-wrapper {
    height: 100%
  }
</style>
<style>
  .wrap {position: absolute;left: 0;bottom: 40px;width: 200px;height: 50px;margin-left: -100px;text-align: left;overflow: hidden;font-size: 12px;font-family: 'Malgun Gothic', dotum, '돋움', sans-serif;line-height: 1.5;}
  .wrap * {padding: 0;margin: 0;}
  .wrap .info {width: 286px;height: 120px;border-radius: 5px;border-bottom: 2px solid #ccc;border-right: 1px solid #ccc;overflow: hidden;background: #fff;}
  .wrap .info:nth-child(1) {border: 0;box-shadow: 0px 1px 2px #888;}
  .info .title {padding: 5px 0 0 10px;height: 30px;background: #eee;border-bottom: 1px solid #ddd;font-size: 18px;font-weight: bold;}
  .info .close {position: absolute;top: 10px;right: 10px;color: #888;width: 17px;height: 17px;background: url('http://t1.daumcdn.net/localimg/localimages/07/mapapidoc/overlay_close.png');}
  .info .close:hover {cursor: pointer;}
  .info .body {position: relative;overflow: hidden;}
  .info .desc {position: relative;margin: 13px 0 0 90px;height: 75px;}
  .desc .ellipsis {overflow: hidden;text-overflow: ellipsis;white-space: nowrap;}
  .desc .jibun {font-size: 11px;color: #888;margin-top: -2px;}
  .info .img {position: absolute;top: 6px;left: 5px;width: 73px;height: 71px;border: 1px solid #ddd;color: #888;overflow: hidden;}
  .info:after {content: '';position: absolute;margin-left: -12px;left: 50%;bottom: 0;width: 22px;height: 12px;background: url('http://t1.daumcdn.net/localimg/localimages/07/mapapidoc/vertex_white.png')}
  .info .link {color: #5085BB;}
</style>
